<template>
  <div>
    <dr-page-player
      :id="currentPage.$ID"
      :value="currentPage"
      :snippets="snippets"
    />
    <v-dialog
      v-if="currentPopupPage"
      v-model="dialog"
      :width="popupWidth"
      :persistent="currentPopupPage.LayoutType === 'modalPopup'"
    >
      <dr-page-player
        :id="currentPopupPage.$ID"
        :value="currentPopupPage"
        :snippets="snippets"
        @close-dialog="dialog = false"
      />
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import mixin from './mixins/mixin'

export default {
  mixins: [mixin],
  computed: {
    dialog: {
      get() {
        return this.currentPopPupPageId !== null
      },
      set() {
        this.$store.commit('setCurrentPopPupPage', null)
      }
    },
    popupWidth() {
      return `${this.currentPopupPage.Width}px`
    }
  }
}
</script>
